import FolderIcon from '~/assets/svg/newSvg/folder.svg?react';
import styles from './FoldersOptions.module.scss';
import cn from 'classnames';
import { useMemo } from 'react';

interface IFolderProps {
  id: number;
  name: string;
  child_folders: IFolderProps[];
}

interface IFolderOptionsProps {
  folders: IFolderProps[];
  nestQuantity: number;
  handleClick: (id: number, name: string) => void;
  selectedId: number | null;
  setSelectedId: (id: number) => void;
}

export const FoldersOptions = ({
  folders,
  nestQuantity,
  handleClick,
  selectedId,
  setSelectedId,
}: IFolderOptionsProps) => {
  const paddingLeft = useMemo(() => nestQuantity * 10, [nestQuantity]);

  return (
    <ul className={styles.folderList}>
      {folders.map(item => (
        <li key={item.id} className={styles.folderItem}>
          <div
            className={cn(
              styles.btnWrapper,
              selectedId === item.id && styles.selected
            )}
            style={{ paddingLeft: `${paddingLeft}px` }}
          >
            <FolderIcon className={styles.btnIcon} />
            <button
              className={styles.itemBtn}
              type="button"
              onClick={() => handleClick(item.id, item.name)}
            >
              {item.name}
            </button>
          </div>
          {item.child_folders.length > 0 && (
            <FoldersOptions
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              folders={item.child_folders}
              nestQuantity={nestQuantity + 1}
              handleClick={handleClick}
            />
          )}
        </li>
      ))}
    </ul>
  );
};
